export { default } from './AboutView';



// WEBPACK FOOTER //
// ./src/components/views/AboutView/index.js